import React, { useContext, useState } from 'react';

import { ReportTable } from '@qality/common-components';
import { DashboardContext } from '@qality/common-pages/src/Dashboard/DashboardProvider';
import { ReportService } from '@qality/common-service';

import { TestExecutionGadgetContent } from './TestExecutionGadget.styled';

const TestExecutionGadgetView: React.FC = () => {
  const { testCaseExecutionReport } = useContext(DashboardContext);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <TestExecutionGadgetContent>
      <ReportTable
        report={ReportService.reports.RecentlyExecutedTestCases}
        providedReportData={testCaseExecutionReport}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </TestExecutionGadgetContent>
  );
};

export default TestExecutionGadgetView;
